function MainMenu(containerObject){
	/* THIS FIX */
	var _this = this;
	
	/* PRIVATE CONSTANTS */
	
	
	/* PRIVATE VARIABLES */
	var mainMenuList;
	var mobileMenuContainer;
	var mobileMenuOpen = false;
	

	/* PUBLIC PROPERTIES */
	this.container = null;
	this.inited = false;
	
	
	/* PRIVATE FUNCTIONS */
	function _construct(){
		_this.container = containerObject;
		_this.init();
	}	


	function initMobileMenu(){
		var menuToggle = $('.mobile-menu-toggle', _this.container);
		var menuWrapper = $('.mobile-menu-wrapper', _this.container);

		menuToggle.click(function(e) {
			e.preventDefault();
			_this.container.toggleClass('open');
			if(_this.container.hasClass('open')){
				menuWrapper.scrollTop(0);
				mobileMenuOpen = true;
			} else {
				mobileMenuOpen = false;
			}
		});
		
		initMobileMenuChildren();
	}
	
	
	function updateMobileSubmenuIcon(submenu, expandIcon) {
		if (submenu.hasClass('visible')) {
			expandIcon.addClass('active');
		} else {
			expandIcon.removeClass('active');
		}
	}
	
	
	function initMobileMenuChildren() {
		// check if menu item has children
		$('li', mobileMenuContainer).each(function(index) {
			var item = $(this);
			if(item.has('ul').length){
				// has children
				item.addClass('has-children');
				var submenu = $('ul', item);
				var expandIcon = $('<button class="button expand">');

				// click-expand handler
				expandIcon.click(function(e) {
					e.preventDefault();
					submenu.toggleClass('visible');
					updateMobileSubmenuIcon(submenu, expandIcon);
				});
				
				// show submenu if item is active
				if(item.hasClass('active')) {
					submenu.addClass('visible');
					updateMobileSubmenuIcon(submenu, expandIcon);
				}
				
				item.append(expandIcon);
			}
		});
	}
	
   
	/* PUBLIC FUNCTIONS */	
	this.init = function(){
		if(!_this.inited){	
			// object references
			mainMenuList = $('.nav-strip nav > ul.sm', _this.container);
			mobileMenuContainer = $('nav.mobile-menu', _this.container);
			
			// init
			mainMenuList.smartmenus({
				subIndicators: false,
			});
			initMobileMenu();

			_this.inited = true;
		}
	};
		

	/* INIT CONSTRUCTOR */
	_construct();
}


/* PUBLIC CONSTANTS */
